$('.js-rp-button').click(function H(e) {
    e.preventDefault();
    $('body').addClass('body-overflow');
    $('.js-rp-popup').addClass('active');
});

$('.js-rp-popup-close').click(function H(e) {
    e.preventDefault();
    $('body').removeClass('body-overflow');
    $('.js-rp-popup').removeClass('active');
});
